export default __webpack_public_path__ + "static/media/download-pdf1.3c24be27.svg";